import { createSlice } from "@reduxjs/toolkit";
import {
  getFavoriteActivities,
  getPremiumActivitiesCount,
  removeFavoriteActivity,
  setSeanceFavorite,
  setTechniqueFavorite,
  setTutorialFavorite,
  setVisualSupportFavorite,
} from "domain/activities/activities.actions";
import { FavoriteActivity } from "domain/entities/activities.entities";

export type ActivitiesState = {
  favoriteSeances: FavoriteActivity[];
  favoriteTechniques: FavoriteActivity[];
  favoriteTutorials: FavoriteActivity[];
  favoriteVisualSupports: FavoriteActivity[];
  isActivitiesLoading: boolean;
  premiumActivitiesCount: number;
};

const initialState: ActivitiesState = {
  favoriteSeances: [],
  favoriteTechniques: [],
  favoriteTutorials: [],
  favoriteVisualSupports: [],
  isActivitiesLoading: false,
  premiumActivitiesCount: 0,
};

export const activitiesSlice = createSlice({
  name: "activities",
  initialState,
  reducers: {},
  extraReducers(builder) {
    //SET TECHNIQUE FAVORITE
    builder.addCase(setTechniqueFavorite.fulfilled, (state, action) => {
      if (action.payload.success && action.payload.technique) {
        state.favoriteTechniques.push(action.payload.technique);
      }
      state.isActivitiesLoading = false;
    });
    builder.addCase(setTechniqueFavorite.pending, (state, action) => {
      state.isActivitiesLoading = true;
    });
    //SET SEANCE FAVORITE
    builder.addCase(setSeanceFavorite.fulfilled, (state, action) => {
      if (action.payload.success && action.payload.seance) {
        state.favoriteSeances.push(action.payload.seance);
      }
      state.isActivitiesLoading = false;
    });
    builder.addCase(setSeanceFavorite.pending, (state, action) => {
      state.isActivitiesLoading = true;
    });
    //SET TUTORIAL FAVORITE
    builder.addCase(setTutorialFavorite.fulfilled, (state, action) => {
      if (action.payload.success && action.payload.tutorial) {
        state.favoriteTutorials.push(action.payload.tutorial);
      }
      state.isActivitiesLoading = false;
    });
    builder.addCase(setTutorialFavorite.pending, (state, action) => {
      state.isActivitiesLoading = true;
    });
    //SET VISUAL SUPPORT FAVORITE
    builder.addCase(setVisualSupportFavorite.fulfilled, (state, action) => {
      if (action.payload.success && action.payload.support) {
        state.favoriteVisualSupports.push(action.payload.support);
      }
      state.isActivitiesLoading = false;
    });
    builder.addCase(setVisualSupportFavorite.pending, (state, action) => {
      state.isActivitiesLoading = true;
    });
    //GET FAVORITE ACTIVITIES
    builder.addCase(getFavoriteActivities.fulfilled, (state, action) => {
      if (action.payload.success && action.payload.activities) {
        state.favoriteTechniques = [];
        state.favoriteSeances = [];
        state.favoriteTutorials = [];
        state.favoriteVisualSupports = [];
        action.payload.activities.forEach((t) => {
          if (t.type === "technique") {
            state.favoriteTechniques.push(t);
          } else if (t.type === "seance") {
            state.favoriteSeances.push(t);
          } else if (t.type === "tutorial") {
            state.favoriteTutorials.push(t);
          } else if (t.type === "visuel") {
            state.favoriteVisualSupports.push(t);
          }
        });
      }
      state.isActivitiesLoading = false;
    });
    builder.addCase(getFavoriteActivities.pending, (state, action) => {
      state.isActivitiesLoading = true;
    });
    //REMOVE FAVORITE ACTIVITY
    builder.addCase(removeFavoriteActivity.fulfilled, (state, action) => {
      state.isActivitiesLoading = false;
    });
    builder.addCase(removeFavoriteActivity.pending, (state, action) => {
      state.isActivitiesLoading = true;
    });
    //GET PREMIUM ACTIVITIES COUNT
    builder.addCase(getPremiumActivitiesCount.fulfilled, (state, action) => {
      state.premiumActivitiesCount = action.payload.count;
      state.isActivitiesLoading = false;
    });
    builder.addCase(getPremiumActivitiesCount.pending, (state, action) => {
      state.isActivitiesLoading = true;
    });
  },
});
